import type { Router } from "vue-router";

let appRouter: Router | undefined;

export function setAppRouter(router: Router): void {
  appRouter = router;
}

const routerProxy = new Proxy({} as Router, {
  get(_, prop) {
    if (!appRouter) {
      throw new Error("Router accessed before initialization (setAppRouter not called yet)");
    }
    const value = appRouter[prop as keyof Router];
    return typeof value === "function" ? value.bind(appRouter) : value;
  },
});

export default routerProxy;
